import axios from 'axios';

async function ObtenerProvincia(prmIdProvincia: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_provincia"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "id_provincia": prmIdProvincia
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerProvincia;